import { NextPage } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetServerSidePropsContext } from "next";
import StrategyFS5_US from "components/pages/strategy/FS5_US";

interface Props {}

const StrategyFS5_USPage: NextPage<Props> = ({}) => {
  return <StrategyFS5_US />;
};
export default StrategyFS5_USPage;

export async function getServerSideProps(context: GetServerSidePropsContext) {
  let locale = context.locale || context.defaultLocale || "ko";

  return {
    props: {
      ...(await serverSideTranslations(locale, ["strategy"])),
    },
  };
}
